import React, { useEffect, useState } from 'react';
import AddToCartModal from '../AddToCartModal';
import Login from '../Login/Login';
import Shoppings from '../Shoppings';
import CategoriesBar from './CategoriesBar';
import Footer from './Footer';
import Header from './Header';
import TopHeader from './TopHeader';
import BottomNavigator from './BottomNavigator';
import { Link, useNavigate } from 'react-router-dom';


const Layout = ({
  children,
  changeLn,
  t,
  login,
  setlogin,
  handleSectionRef,
  setHomePageSearchedResultProducts,
  setSelectedCategoryId
}) => {
  const [activeTab, setActiveTab] = useState('home');
  const [cartCount, setCartCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("from layout", login);
  }, [login]);

  // Function to handle tab changes
  const handleTabChange = (tabId, path) => {
    setActiveTab(tabId);
    
    // Add your navigation logic here
    // For example, if using React Router:
    // navigate(path);
    
    console.log(`Navigate to: ${path}`);
    
    // You can also trigger different actions based on the tab
    switch(tabId) {
      case 'home':
        // Navigate to home or trigger home actions
        navigate('/');
        break;
      case 'categories':
        // Navigate to categories or trigger category actions
        navigate('/search');
        break;
      case 'cart':
        // Navigate to cart or trigger cart actions
        navigate('/viewPage');
        break;
      case 'notifications':
        // Navigate to notifications or trigger notification actions
        break;
      case 'account':
        // Navigate to account or trigger account actions
        if (!login) {
          setlogin(true); // Show login modal if not logged in
        }
        break;
      default:
        break;
    }
  };

  // Example: Update cart count from your cart context/state
  useEffect(() => {
    // Replace this with your actual cart count logic
    // const count = getCartItemsCount();
    // setCartCount(count);
  }, [/* your cart dependencies */]);

  // Example: Update notification count from your notification context/state
  useEffect(() => {
    // Replace this with your actual notification count logic
    // const count = getUnreadNotificationsCount();
    // setNotificationCount(count);
  }, [/* your notification dependencies */]);

  // Function to update active tab based on current route
  const updateActiveTabFromRoute = () => {
    const currentPath = window.location.pathname;
    
    if (currentPath === '/') {
      setActiveTab('home');
    } else if (currentPath.startsWith('/search')) {
      setActiveTab('categories');
    } else if (currentPath.startsWith('/viewPage')) {
      setActiveTab('cart');
    } else if (currentPath.startsWith('/notifications')) {
      setActiveTab('notifications');
    } else if (currentPath.startsWith('/account') || currentPath.startsWith('/profile')) {
      setActiveTab('account');
    }
  };

  // Update active tab when component mounts or route changes
  useEffect(() => {
    updateActiveTabFromRoute();
    
    // Listen for route changes (if using React Router)
    // const unlisten = history.listen(() => {
    //   updateActiveTabFromRoute();
    // });
    // return unlisten;
  }, []);

  return (
    <>
      <TopHeader setlogin={setlogin} t={t} changeLn={changeLn} />        
      <Header
        handleSectionRef={handleSectionRef}
        t={t}
        setHomePageSearchedResultProducts={setHomePageSearchedResultProducts}
        setSelectedCategoryId={setSelectedCategoryId}
      />
      <CategoriesBar t={t} />
      
      {/* Add main-content class to ensure proper spacing above bottom navigator */}
      <div className="main-content">
        {children}
      </div>
      
      <Shoppings t={t} />
      <Footer t={t} />
      
      {login && (
        <Login show={login} setlogin={setlogin} />
      )}

      <AddToCartModal />
      
      {/* Bottom Navigator */}
      <BottomNavigator
        activeTab={activeTab}
        onTabChange={handleTabChange}
        cartCount={cartCount}
        notificationCount={notificationCount}
        t={t}
      />
    </>
  );
};

export default Layout;